module.exports = __webpack_public_path__ + "static/img/yanghui_notice.44721ae6.png";